export const GET_WEBSTOCK_PRODUCTS = 'GET_WEBSTOCK_PRODUCTS';
export const UPDATE_WEBSTOK_PRODUCT = 'UPDATE_WEBSTOK_PRODUCT';
export const GET_PRODUCTS_BY_SKU = 'GET_PRODUCTS_BY_SKU';
